export function setCurrentTime() {
    return {type: "SET_CURRENT_TIME"};
}
